var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',[_c('VFlex',{attrs:{"sm12":"","md12":""}},[_c('h1',{staticClass:"primary--text mb-4"},[_vm._v("\n      "+_vm._s(_vm.$nt('heading'))+"\n    ")]),_c('VCard',[_c('VFlex',{attrs:{"xs12":""}},[_c('AgencyEdit')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }